import { useEffect } from 'react';
import useIsMobile from 'hooks/useIsMobile';
import { useHistory } from 'react-router-dom';

function useBackHandler({ hashKey, open, onClose }) {
  const hash = hashKey && `#overlay-${hashKey}`;
  const isMobile = useIsMobile();
  const history = useHistory();

  useEffect(() => {
    if (!hash || !isMobile) {
      return;
    }
    if (open && window.location.hash !== hash) {
      // window.history.pushState(null, '', hash);
      history.push(hash);
    }
    if (!open && window.location.hash === hash) {
      // window.history.replaceState(null, '', window.location.pathname);
      history.replace(window.location.pathname.replace('/pwa', ''));
      // window.history.back();
      // setTimeout(() => {
      history.goBack();
      // }, 10);
    }
  }, [open, hash, isMobile, history]);

  useEffect(() => {
    if (!hash || !open) {
      return;
    }
    const onHashChange = ({ newURL, oldURL }) => {
      const newHash = new URL(newURL).hash;
      const oldHash = new URL(oldURL).hash;
      if (oldHash === hash && newHash !== hash && open) {
        onClose();
      }
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [hash, onClose, open, isMobile]);
}

export default useBackHandler;
